import { Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs';
import { Color, SnackbarService } from 'src/app/libs/snackbar/snackbar.service';
import { NotificationModel } from 'src/app/models/common.model';

import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly DEFAULT_DURATION = 8000;

  constructor(private injector: Injector, private snackbarService: SnackbarService) {}

  snackbarVisibility: Subject<boolean> = new Subject<boolean>();

  successNotification(notification: NotificationModel): void {
    const commonService = this.injector.get(CommonService);
    this.clearAllNotifications();
    this.snackbarService.show({
      message: notification.message || commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
      duration: notification.duration || this.DEFAULT_DURATION,
      actions: notification.actions || [],
      color: Color.Success,
    });
  }

  errorNotification(notification: NotificationModel): void {
    this.clearAllNotifications();
    this.snackbarService.show({
      message: notification.message || ' Hatalıİşlem',
      duration: notification.duration || this.DEFAULT_DURATION,
      actions: notification.actions || [],
      color: Color.Error,
    });
  }

  warningNotification(notification: NotificationModel): void {
    this.clearAllNotifications();
    this.snackbarService.show({
      message: notification.message || 'Uyarı',
      duration: notification.duration || this.DEFAULT_DURATION,
      actions: notification.actions || [],
      color: Color.Warning,
    });
  }

  defaultNotification(notification: NotificationModel): void {
    const commonService = this.injector.get(CommonService);
    this.clearAllNotifications();
    this.snackbarService.show({
      message: notification.message || commonService.getTranslatedMessage('OPERATION_SUCCESSFUL'),
      duration: notification.duration || this.DEFAULT_DURATION,
      actions: notification.actions || [],
      color: Color.Default,
    });
  }

  clearAllNotifications(): void {
    this.snackbarService.snackbars.forEach((snackbar) => this.snackbarService.close(snackbar));
  }

  translateAndShowError(error: any): void {
    const errorKey = error.error.message;
    const commonService = this.injector.get(CommonService);
    if (errorKey) {
      const translatedMessage = commonService.getTranslatedMessage(errorKey);
      if (translatedMessage !== errorKey && translatedMessage !== '') {
        this.errorNotification({ message: translatedMessage });
      } else {
        console.log(error);
      }
    }
  }
}
